import { BuilderService } from './services/builder.service';
import Vue from 'vue';
import { BuilderServiceQueue } from './services/queue-builder.service';

export class BuilderModule extends Vue {

  Services = BuilderService;
  Queue    = BuilderServiceQueue;

}